import { all } from 'redux-saga/effects';

import auth from './auth';
import health from './health';
import support from './support';
import tasks from './tasks';

export default function* rootSaga() {
    yield all([
        ...auth,
        ...health,
        ...support,
        ...tasks,
    ]);
}